import React from 'react'
import styled from 'styled-components'

import { commonSpinnerStyles } from './Spinner'

const StyledSpinnerContents = styled.div<{ $size: number }>`
  ${commonSpinnerStyles};
  height: ${({ $size }) => $size}px;
  width: ${({ $size }) => $size}px;
`

export interface InlineSpinnerProps {
  className?: string
  loading?: boolean
  processing?: boolean
  size?: number
}

// This accepts both loading and processing so the semantically-appropriate prop can be
// used whether the user is waiting for data to load or waiting on the response to an
// action taken by the user.
const InlineSpinner: React.VFC<InlineSpinnerProps> = ({
  className,
  loading = false,
  processing = false,
  size = 16,
}) => {
  if (loading || processing) {
    return (
      <div className={className}>
        <StyledSpinnerContents $size={size} />
      </div>
    )
  }

  return null
}

export default InlineSpinner
